import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '@/App';
import { User } from 'lucide-react';
import NotificationBell from './NotificationBell';

const MobileHeader = ({ title = "Portal de Gastos" }) => {
  const { user } = useContext(AuthContext);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY <= 10) {
        setVisible(true);
      } else if (currentScrollY > lastScrollY.current + 5 && currentScrollY > 50) {
        // Scroll hacia abajo: ocultar
        setVisible(false);
      } else if (currentScrollY < lastScrollY.current - 5) {
        // Scroll hacia arriba: mostrar
        setVisible(true);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Barra sólida fija para el Status Bar en iOS (evita que el contenido scrollee detrás de los iconos de batería/reloj de forma borrosa) */}
      <div 
        className="fixed top-0 left-0 right-0 z-50 bg-slate-50"
        style={{ height: 'env(safe-area-inset-top)' }}
      />
      <header
        className={`fixed top-0 left-0 right-0 bg-slate-50 border-b border-slate-200/80 z-40 px-5 pb-2.5 flex items-center justify-between transition-transform duration-300 ease-in-out ${
          visible ? 'translate-y-0' : '-translate-y-full'
        }`}
        style={{ paddingTop: 'calc(env(safe-area-inset-top) + 0.75rem)' }}
      >
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
        
        <div className="flex items-center gap-4">
          {/* Notificaciones */}
          <div className="relative">
            <NotificationBell />
          </div>

          {/* Perfil */}
          <Link to="/profile" className="relative active:scale-95 transition-transform">
            {user?.profile_image ? (
              <img
                src={user.profile_image}
                alt={user.username || 'Perfil'}
                className="w-10 h-10 rounded-full border-2 border-white shadow-sm object-cover"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center border-2 border-white shadow-sm">
                <User className="w-6 h-6 text-white" />
              </div>
            )}
          </Link>
        </div>
      </header>
    </>
  );
};

export default MobileHeader;


